module.exports = __webpack_public_path__ + "fonts/Lato-Semibold.c2b50f4a.woff";